module.exports = __webpack_public_path__ + "img/untitled.438.d34dfcc0.png";